import React, { useEffect, useState } from "react";
import "./index.css";
import { TagColorOptions, XlsNormalizefileKey } from "../utils/constantsString";
import ChartPlot from "../components/plot";
import Select, { components } from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { storeSelectedValues } from "../Store/TemplateStore/template.action";
import { useTranslation } from "react-i18next";
import { getHeaders } from "../network/cipAPI";

const Charts = ({ cleaningResponse, date, cips, threshold, activeStep }) => {
  const { t, i18n } = useTranslation();
  const normalizedCategories = [
    XlsNormalizefileKey.normalizeSaltPassage,
    XlsNormalizefileKey.normalizeDPRack2,
    XlsNormalizefileKey.normalizePermeateFlow,
  ];
  const otherCategories = [
    XlsNormalizefileKey.date,
    XlsNormalizefileKey.feedFlowrate,
    XlsNormalizefileKey.concentrateFlowrate,
    XlsNormalizefileKey.permeateFlow,
    XlsNormalizefileKey.feedPressure,
    XlsNormalizefileKey.concentratePressure,
    XlsNormalizefileKey.permeatePressure,
    XlsNormalizefileKey.pressureDrop,
    XlsNormalizefileKey.feedQuality,
    XlsNormalizefileKey.permeateConductivity,
    XlsNormalizefileKey.feedTemp,
  ];
  const [selectedValues, setSelectedValues] = useState(
    useSelector((state) => state.selectedValues)
  );
  const [options, setOptions] = useState(null);
  const [headerOptions, setHeaderOptions] = useState(null);
  const [selectedValuesUpdated, setSelectedValuesUpdated] = useState(null);
  const dispatch = useDispatch();

  const getColor = (key, index) => {
    if (key.label === XlsNormalizefileKey.normalizePermeateFlow) {
      return "#00A9E0";
    } else if (key.label === XlsNormalizefileKey.permeateFlow) {
      return "#0000FF";
    } else if (key.label === XlsNormalizefileKey.concentrateFlowrate) {
      return "#4682B4";
    } else if (key.label === XlsNormalizefileKey.feedFlowrate) {
      return "#0818A8";
    } else if (key.label === XlsNormalizefileKey.normalizeDPRack2) {
      return "#58B947";
    } else if (key.label === XlsNormalizefileKey.feedPressure) {
      return "#228B22";
    } else if (key.label === XlsNormalizefileKey.pressureDrop) {
      return "#00A36C";
    } else if (key.label === XlsNormalizefileKey.permeatePressure) {
      return "#40B5AD";
    } else if (key.label === XlsNormalizefileKey.concentratePressure) {
      return "#008080";
    } else if (key.label === XlsNormalizefileKey.permeateConductivity) {
      return "#8B0000";
    } else if (key.label === XlsNormalizefileKey.feedQuality) {
      return "#FF0000";
    } else if (key.label === XlsNormalizefileKey.normalizeSaltPassage) {
      return "#e4001c";
    } else if (key.label === XlsNormalizefileKey.feedTemp) {
      return "#FF9E19";
    } else if (key.label === XlsNormalizefileKey.date) {
      return "#C900E3";
    }
    return TagColorOptions[index % 10].code;
  };

  const getThreshold = (key) => {
    if (threshold) {
      if (Array.isArray(threshold) && threshold[0]) {
        return [threshold[0][key]];
      } else if (threshold[key]) {
        return [threshold[key]];
      }
    }
    return [];
  };

  const NoOptionsMessage = (props) => {
    return (
      <components.NoOptionsMessage {...props}>
        <span className="custom-css-class">{t("ValueStrings.noOption")}</span>
      </components.NoOptionsMessage>
    );
  };

  useEffect(() => {
    const fetchHeader = async () => {
      let headerResponse = await getHeaders();
      headerResponse = headerResponse?.data;
      if (headerResponse) {
        const normalizedOptions = [];
        const others = [];
        Object.keys(headerResponse).forEach((key, index) => {
          if (key !== "Date (MM/DD/YYYY)" && key !== "Date") {
            if (normalizedCategories.includes(key)) {
              normalizedOptions.push({
                label: key,
                value: headerResponse[key],
              });
            } else if (otherCategories.includes(key)) {
              others.push({ label: key, value: headerResponse[key] });
            }
          }
        });

        const options = [];
        options.push({
          label: t("ValueStrings.normalized"),
          options: normalizedOptions,
        });
        options.push({ label: t("ValueStrings.others"), options: others });
        setOptions(options);

        if (!selectedValues || selectedValues.length === 0) {
          setSelectedValues(normalizedOptions);
          dispatch(storeSelectedValues(normalizedOptions));
        }
        setHeaderOptions(headerResponse);
      }
    };
    fetchHeader();
  }, []);

  useEffect(() => {
    if (selectedValues && selectedValues.length > 0 && headerOptions !== null) {
      selectedValues.map((header) => {
        return (header.value = headerOptions[header.label]);
      });
      setSelectedValuesUpdated(true);
    }
  }, [headerOptions]);

  const onCheckChange = (value, key) => {
    setSelectedValues(value);
    dispatch(storeSelectedValues(value));
  };

  return (
    <div>
      <div className="tabsContainer">
        {selectedValuesUpdated && (
          <div>
            <div style={{ minWidth: "400px", marginRight: "20px" }}>
              {/* <div className="descriptionText marginTop10 marginBtm10">
                {t("IdentifiedCIPStrings.chartDescription")}
              </div> */}
              <Select
                id="chart-select"
                options={options}
                name="label"
                value={selectedValues}
                isMulti
                GroupType="cat"
                onChange={onCheckChange}
                placeholder={t("ValueStrings.select")}
                components={{ NoOptionsMessage }}
                getOptionLabel={(option) => option.value}
              />
            </div>
            {selectedValues && selectedValues?.length > 0 && (
              <div
                style={{
                  display: "flex",
                  marginTop: "10px",
                  justifyContent: "center",
                }}
              >
                {(activeStep === 2 || activeStep === 3) && (
                  <div style={{ color: "red", fontSize: 12 }}>
                    <span
                      style={{
                        fontWeight: "bold",
                        fontSize: "16px",
                        marginRight: 2,
                      }}
                    >
                      {" "}
                      |
                    </span>
                    {t("IdentifiedCIPStrings.dottedLineCleaningAdvisor")}
                  </div>
                )}

                <div style={{ fontSize: 12, marginLeft: 16 }}>
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      marginRight: 2,
                    }}
                  >
                    {" "}
                    |
                  </span>
                  {t("IdentifiedCIPStrings.blackLines")}
                </div>
                <div style={{ color: "red", fontSize: 12, marginLeft: 16 }}>
                  <span
                    style={{ fontWeight: "bold", fontSize: 16, marginRight: 2 }}
                  >
                    {" "}
                    |
                  </span>{" "}
                  {t("IdentifiedCIPStrings.redLine")}
                </div>
              </div>
            )}
            <div
              style={{
                marginTop: "20px",
                maxHeight: "70vh",
                overflowY: "scroll",
              }}
              className=""
            >
              {cleaningResponse &&
                selectedValues &&
                selectedValues.map((key, index) => (
                  <div key={`chart-${key["label"]}-${index}`}>
                    <ChartPlot
                      key={`plot-${key["label"]}-${index}`}
                      title={key["value"]}
                      label={key["label"]}
                      data={cleaningResponse[key["label"]]}
                      color={getColor(key, index)}
                      date={date}
                      cips={cips}
                      i18n={i18n}
                      showCIPs
                      threshold={getThreshold(key["label"])}
                    />
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Charts;
